export default "__VITE_ASSET__826df97b__"